import { css } from 'styled-components';
import { borderDecorator } from './borderDecorator';

export const buttonBorderAndColorDecorator = (color: string = '#851bb7') => css`
	${borderDecorator({ b: `1px solid ${color};` })};
	color: ${color};
`;
